import React from 'react'
import { Row } from 'react-bootstrap';

interface PrivacyPolicyProps {
    title: string;
}

export const PrivacyPolicy = (props: PrivacyPolicyProps) => {
    const { title } = props;
    return (
        <Row className="p-3 pb-5 g-4 open-up" data-aos="zoom-out">
            <h5 className='mb-3'>{ title }</h5>
            <div className="mb-4">
                <p className='text-muted' style={{ fontSize: '1rem' }}>
                    At Easysauces Nigeria limited we value your privacy and are committed to protecting your personal information. <br />
                    This Privacy Policy explains how we collect, use, and safeguard your personal data when you visit our website at &nbsp;
                    <a href="https://easysauce.com">www.easysauce.com</a>

                </p>

                <p className='text-muted' style={{ fontSize: '.9rem' }}>
                
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5 mb-3'>What Personal Data Do We Collect?</h5>
                    <p>We collect the following personal data:</p>
                    <ul className='text-muted'>
                        <li>Name</li>
                        <li>Email Address</li>
                        <li>Phone number</li>
                        <li>Delivery address (for order fulfillment)</li>
                        <li>Payment information (through our secure payment gateway)</li>
                    </ul>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5 mb-3'>How Do We Use Your Personal Data?</h5>
                    <p>We use your personal data for the following purposes:</p>
                    <ul className='text-muted'>
                        <li>To process and fulfill your orders</li>
                        <li>To communicate with you about your orders, promotions, and new products</li>
                        <li>To improve our website and services</li>
                        <li>To comply with legal and regulatory requirements</li>
                    </ul>
                    

                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5 mb-3'>How Do We Protect Your Personal Data?</h5>
                    <p>We take reasonable measures to ensure the security and confidentiality of your personal data, including:</p>
                    <ul className='text-muted'>
                        <li>Using secure servers and encryption</li>
                        <li>Implementing access controls and authentication</li>
                        <li>Regularly updating our security measures</li>
                        <li>To comply with legal and regulatory requirements</li>
                    </ul>

                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5 mb-3'>Do We Share Your Personal Data?</h5>
                    <p>We may share your personal data with:</p>
                    <ul className='text-muted'>
                        <li>Our logistics partners for delivery purposes</li>
                        <li>Our payment gateway providers for secure payment processing</li>
                        <li>Law enforcement agencies or regulatory bodies as required by law</li>
                    </ul>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5 mb-3'>Your Rights</h5>
                    <p>You have the right to:</p>
                    <ul className='text-muted'>
                        <li>Access and update your personal data</li>
                        <li>Request deletion of your personal data</li>
                        <li>Object to processing of your personal data</li>
                    </ul>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5 mb-2'>Contact Us:</h5>
                    <p className='mb-0'>If you have any questions or concerns about our Privacy Policy, please contact us at  <a href='mailto:info@easysauces.com'>info@easysauces.com</a></p>
                    <p>By using our website, you acknowledge that you have read, understood, and agree to be bound by this Privacy Policy.</p>
                    
                    <h5 style={{ fontSize: '1rem', fontWeight: 600 }} className='mt-5 mb-2'>Changes to This Policy</h5>
                    <p className='mb-0'>We reserve the right to update this Privacy Policy at any time without prior notice.</p>
                    
                    <p className='mt-5 mt-0'>Thank you for choosing,</p>
                    <h5 style={{ fontSize: '1rem', fontWeight: 400 }} className='mt-1'>Easysauces Nigeria limited.</h5>
                </p>
            </div>
        </Row>
    )
}
